import { render } from "./AptMarketSummary.vue?vue&type=template&id=623e9d7d&ts=true"
import script from "./AptMarketSummary.vue?vue&type=script&lang=ts"
export * from "./AptMarketSummary.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__